export const COOKIE_CONSENT_SETTINGS = 'cookie-consent-settings';
